module.exports = __webpack_public_path__ + "static/Abriss_Hotel2-3eb82b8cbc86a1774cd5464e30ba1cab.png";